import Game from '../../Game';
import BaseUISystem from './BaseUISystem';
import NoCoinsMenuHandler from './NotImplemented/NoCoinsMenuHandler';
import ThreeStarRewardMenuHandler from './NotImplemented/ThreeStarRewardHandler';
import WorldHUDHandler from './HUD/WorldHUDHandler';
import FieldHarvestHandler from './Menu/FieldHarvestHandler';
import FieldUnlockedHandler from './Menu/FieldUnlockedHandler';
import MoreLevelsComingHandler from './NotImplemented/MoreLevelsComingHandler';
import CropUnlockedHandler from './Menu/CropUnlockedHandler';
import FriendsHubHandler from './Menu/FriendsHubHandler';
import GiftMenuHandler from './Menu/GiftMenuHandler';
import SentGiftMenuHandler from './Menu/SentGiftMenuHandler';
import InfoMenuHandler from './Menu/InfoMenuHandler';
import CropUnlockedShareHandler from './Menu/CropUnlockedShareHandler';
import { ShopPopup } from './Menu/ShopPopup/ShopPopup';
import WorldHUDTravelHandler from './HUD/WorldHUDTravelHandler';
import CrossPromoMenuHandler from './Menu/CrossPromoMenuHandler';
import CrossPromoHUDHandler from './HUD/CrossPromoHUDHandler';
import { BotOptStatus, CrossPromoStatus } from '../../State/Game/IUserState';
import StarChestInfoHandler from './Menu/StarChestInfoHandler';
import SpecialOfferHandler from './Menu/SpecialOfferHandler';
import QuestsMenuHandler from './Menu/QuestsMenuHandler';
import DailyLoginMenuHandler from './Menu/DailyLoginMenuHandler';
import SundayOfferHandler from './Menu/SundayOfferHandler';
import { PlayerActions } from '../../State/Player/PlayerActions';
import ThankYouFirstPurchaseHandler from './Menu/ThankYouFirstPurchaseHandler';
import PayerReactivationHandler from './Menu/PayerReactivationHandler';
import PetUnlockMenuHandler from './Menu/PetUnlockMenuHandler';
import PrePetMiniGameMenuHandler from './Menu/PrePetMiniGameMenuHandler';
import { QuestStateHelper } from '../../State/Player/Quests/QuestStateHelper';
import { LevelPopup } from './Menu/LevelPopup/LevelPopup';
import { BuyBoosterPopup } from './Menu/LevelPopup/BuyBoosterPopup';
import WheelPopup from './WheelPopup/WheelPopup';
import { WheelQuitConfirmPopup } from './WheelPopup/WheelQuitConfirmPopup';
import ConfirmSignOutMenuHandler from './Menu/ConfirmSignOutMenuHandler';
import DataConflictsMenuHandler from '@platform/System/UI/Menu/DataConflictsMenuHandler';
import ConfirmQuitGameHandler from './Menu/ConfirmQuitGameHandler';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';
import { UnlockItemsPopup } from './Menu/FarmPopup/UnlockItemsPopup';
import ConnectFbPopup from 'System/UI/Menu/ConnectFbPopup';
import ProgressionPassedMobileVersion from 'System/UI/Menu/ProgressionPassedMobileVersion';
import ErrorPopupHandler from 'System/UI/ErrorPopupHandler';
import { SettingsPopup } from '@platform/System/UI/Menu/SettingsPopup';
import EventIntroHandler from 'System/UI/Menu/EventIntroHandler';
import { FTUXStateHelper } from 'State/Game/FTUX/FTUXStateHelper';
import ThreeStarShareHandler from './Menu/ThreeStarShareHandler';
import HardSharePopup from './Menu/LevelPopup/HardSharePopup';
import GBCDisconnectedMenuHandler from './Menu/GBCDisconnectedMenuHandler';
import { CurrentEventOfferHandler } from 'Constants/Events/CurrentEvent';

export default class WorldUISystem extends BaseUISystem {
    public hud: WorldHUDHandler;

    public init(): void {
        this.hud = new WorldHUDHandler(this);

        this.handlers = [
            this.hud,
            new WorldHUDTravelHandler(this),
            new LevelPopup(this),
            new BuyBoosterPopup(this),
            new WheelPopup(this),
            new WheelQuitConfirmPopup(this),
            new FriendsHubHandler(this),
            new SettingsPopup(this),
            new NoCoinsMenuHandler(this),
            new ThreeStarRewardMenuHandler(this),
            new FieldHarvestHandler(this),
            new FieldUnlockedHandler(this),
            new CropUnlockedHandler(this),
            new MoreLevelsComingHandler(this),
            new GiftMenuHandler(this),
            new SentGiftMenuHandler(this),
            new InfoMenuHandler(this),
            new CropUnlockedShareHandler(this),
            new ShopPopup(this),
            new StarChestInfoHandler(this),
            new SpecialOfferHandler(this),
            new PayerReactivationHandler(this),
            new SundayOfferHandler(this),
            new DailyLoginMenuHandler(this),
            new ThankYouFirstPurchaseHandler(this),
            new PetUnlockMenuHandler(this),
            new PrePetMiniGameMenuHandler(this),
            new ConfirmSignOutMenuHandler(this),
            new DataConflictsMenuHandler(this),
            new ConfirmQuitGameHandler(this),
            new UnlockItemsPopup(this),
            new ProgressionPassedMobileVersion(this),
            new ErrorPopupHandler(this),
            new CurrentEventOfferHandler(this),
            new ThreeStarShareHandler(this),
            new HardSharePopup(this),
            new GBCDisconnectedMenuHandler(this),
        ];

        const state = Game.store.getState();
        if (state.platform.IAPSupport) {
            //this.handlers.push(new ShopPopup(this));
            //this.handlers.push(new ShopHUD(this));
        }

        if (state.userState.subscribeBot === BotOptStatus.ENABLED) {
            //this.handlers.push(new BotOptInMenu(this));
            //this.handlers.push(new BotOptInHUD(this));
        }

        // if (state.userState.crossPromo === CrossPromoStatus.ENABLED) {
        //     this.handlers.splice(0, 0, new CrossPromoMenuHandler(this));
        //     this.handlers.splice(1, 0, new CrossPromoHUDHandler(this));
        // }

        if (QuestStateHelper.isQuestsFeatureUnlocked(state.playerState)) {
            this.handlers.push(new QuestsMenuHandler(this));
        }

        // if (FTUXStateHelper.shouldQueueEventFTUX(state)) {
        //     this.handlers.push(new EventIntroHandler(this));
        // }

        // if (ConnectFbPopup.canShow()) {
        //     this.handlers.push(new ConnectFbPopup(this));
        // }
    }

    public async onStart() {
        super.onStart();
        const state = Game.store.getState();
        CrossPromoHUDHandler.startLoading(this.scene);

        // await Game.sdk.waitForPaymentsEnabled();
        // await Game.sdk.fetchCatalog();

        // if (IAPStateHelper.hasAvailableOffer(state)) {
        //     PlayerActions.showOfferPopups(true);
        // }
    }
}
